const translations: Record<string, string> = {
  "ak_contacts_duty_dispatcher": "Черговий диспетчер",
  "ak_contacts_dso_emergency_service": "Аварійна служба ОСР",
  "ak_contacts_state_emergency_service": "ДСНС",
  "ak_contacts_fire_smoke": "пожежа, задимлення",
  "ak_contacts_police": "Поліція",
  "ak_contacts_break_in_theft": "проникнення, крадіжка",
  "ak_contacts_operations_management": "Операційне управління",
  "ak_contacts_helios_aggregator_llc": "ТОВ «ГЕЛІОС АГРЕГАТОР»",
  "ak_contacts_technical_maintenance": "Технічне обслуговування",
  "ak_contacts_helios_strategia_llc": "ТОВ «ГЕЛІОС СТРАТЕГІЯ»",
  "ak_contacts_trading": "Трейдінг",
  "ak_contacts_tepla_llc": "ТОВ «ТЕПЛА»",
  "ak_contacts_aggregating_group": "Агрегуюча група",
  "ak_contacts_servicing_bank": "Обслуговуючий банк",
  "ak_contacts_oschadbank_jsc": "АТ «ОЩАДБАНК»",
  "ak_contacts_transmission_system_operator": "Оператор системи передачі",
  "ak_contacts_npc_ukrenergo": "НЕК «УКРЕНЕРГО»",
  "ak_contacts_distribution_system_operator": "Оператор системи розподілу",
  "ak_contacts_zakarpattiaoblenergo_pjsc": "ПРАТ «ЗАКАРПАТТЯОБЛЕНЕРГО»",
  "ak_contacts_market_operator_se": "ДП «ОПЕРАТОР РИНКУ»",
  "ak_contacts_guaranteed_buyer_se": "ДП «ГАРАНТОВАНИЙ ПОКУПЕЦЬ»",
  "ak_contacts_ministry_of_energy_of_ukraine": "МІНІСТЕРСТВО ЕНЕРГЕТИКИ УКРАЇНИ",
  "ak_contacts_neurc": "НКРЕКП",
  "ak_contacts_state_energy_supervision_inspectorate": "ДЕРЖЕНЕРГОНАГЛЯД",
  "ak_contacts_state_emergency_service_2": "ДСНС",
  "ak_contacts_state_environmental_inspectorate": "ДЕРЖЕКОІНСПЕКЦІЯ",
  "ak_contacts_number_not_specified": "Номер не вказано",
  "ak_contacts_contacts": "Контакти",
  "ak_contacts_emergencies": "Екстрені ситуації",
  "ak_contacts_24_7": "цілодобово",
  "ak_contacts_counterparties": "Контрагенти",
  "ak_contacts_market": "Ринок",
  "ak_contacts_state": "Держава",
  "ak_contacts_helios_strategia": "Геліос Стратегія",
};

export default translations;
